export default "/warning.63815e64a58c373cbca5df83bdbb3da4.svg";